import { type JSX } from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

// Nudge only, never a gate: the ICO registration is the practice's own
// obligation to a third party. Owner-only — the only role who can act on it.
export function IcoRegistrationBanner({
  practiceId,
  icoRegistrationNumber,
  icoRegistrationExpiresAt,
}: {
  practiceId: string;
  icoRegistrationNumber: string | null;
  icoRegistrationExpiresAt: number | null;
}): JSX.Element {
  const expired = icoRegistrationNumber !== null && icoRegistrationExpiresAt !== null;
  const message =
    icoRegistrationNumber !== null && icoRegistrationExpiresAt !== null
      ? `This practice's ICO registration expired on ${new Date(icoRegistrationExpiresAt).toLocaleDateString('en-GB', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}.`
      : 'This practice has no current ICO registration on record.';

  return (
    <div
      role="status"
      data-testid="ico-registration-banner"
      className="flex flex-wrap items-center justify-between gap-2 border-b border-watch/30 bg-watch-bg px-4 py-2 text-sm text-watch"
    >
      <span className="flex items-center gap-2">
        <ShieldAlert className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span>{message}</span>
      </span>
      <Link
        to={`/practices/${practiceId}/settings`}
        data-testid="ico-registration-review"
        className="rounded-md border border-watch/30 px-3 py-1 font-medium hover:bg-watch-bg"
      >
        {expired ? 'Update it now' : 'Record it now'}
      </Link>
    </div>
  );
}
